const styles = {
  container: {
    marginBottom: "90px",
  },
  blue: {
    color: "rgb(33,77,142)",
    paddingRight: "0",
  },
  red: {
    color: "rgb(220,38,72)",
    paddingLeft: "0",
  },
  flexContainer: {
    display: "flex",
    paddingTop: "0",
  },
  spinner: {
    marginTop: "30vh",
  },
  orderButtonContainer: {
    position: "fixed",
    padding: "10px 16px 23px",
    zIndex: 2,
    backgroundColor: "#fff",
    bottom: "0",
    left: "0",
    right: "0",
    display: "flex",
  },
  orderButton: {
    margin: "0 auto",
    backgroundColor: "#06844D",
    borderRadius: "8px",
    width: "87vw",
    height: "44px",
  },
  headerText: {
    color: "#000000",
    fontSize: "23px",
    lineHeight: "28px",
    fontWeight: "400",
    fontFamily: "IBM Plex Sans",
    marginTop: "10px",
    marginLeft: "18px",
    marginBottom: "28px",
  },
  avatar: {
    height: "40px",
    width: "40px",
  },
  invisible: {
    visibility: "hidden",
  },
  visible: {
    visibility: "visible",
  },
};
export default styles;
